export const settingsRoutes = [
    {
        path: 'settings/users',
        name: 'SettingsUsers',
        component: () => import('./views/Users.vue')
    },
    {
        path: 'settings/change-password',
        name: 'SettingsChangePassword',
        component: () => import('./views/ChangePassword.vue')
    },
    {
        path: 'settings/update-profile',
        name: 'SettingsUpdateProfile',
        component: () => import('./views/UpdateProfile.vue')
    },
    {
        path: 'settings/users/invite',
        name: 'InviteUser',
        component: () => import('./views/InviteUser.vue')
    },
    {
        path: 'settings/users/invite/edit/:inviteId',
        name: 'EditUserInvite',
        component: () => import('./views/InviteUser.vue')
    },
    {
        path: 'settings/translation',
        name: 'SettingsTranslation',
        component: () => import('./views/Translation.vue')
    },
    {
        path: 'settings/document-branding',
        name: 'SettingsDocumentBranding',
        component: () => import('./views/DocumentBranding.vue')
    },
    {
        path: 'settings/check-print',
        name: 'SettingsCheckPrint',
        component: () => import('./views/CheckPrintSetting.vue')
    },
    {
        path: 'settings/email-setup',
        name: 'SettingsEmailSetup',
        component: () => import('./views/EmailSetup.vue')
    },
    {
        path: 'settings/email-signature',
        name: 'SettingsEmailSignature',
        component: () => import('./views/EmailSignature.vue')
    },
    {
        path: 'settings/integration-keys',
        name: 'SettingsIntegrationKeys',
        component: () => import('./views/IntegrationKeysView.vue')
    },
    {
        path: 'settings/dunning-letter-categories',
        name: 'SettingsDunningLetterCategories',
        component: () => import('./views/DunningLetterCategoriesConfig.vue')
    },
    {
        path: 'settings/ui-preferences',
        name: 'SettingsUIPreferences',
        component: () => import('./views/UIPreferences.vue')
    },
    {
        path: 'settings/session-alert',
        name: 'SettingsSessionAlert',
        component: () => import('./views/SessionAlertSettings.vue')
    },
    {
        path: 'settings/account-configuration',
        name: 'SettingsAccountConfiguration',
        component: () => import('./views/AccountConfiguration.vue')
    },
    {
        path: 'settings/data-export',
        name: 'SettingsDataExport',
        component: () => import('./views/DataExport.vue')
    },
    {
        path: 'settings/data-import',
        name: 'SettingsDataImport',
        component: () => import('./views/DataImport.vue')
    },
    {
        path: 'settings/journal-entry-guide',
        name: 'SettingsJournalEntryGuide',
        component: () => import('./views/JournalEntryGuide.vue')
    },
    {
        path: 'settings/messaging-notifications',
        name: 'SettingsMessagingNotifications',
        component: () => import('./views/MessagingNotificationsSettings.vue')
    },
    {
        path: 'settings/email-notifications',
        name: 'SettingsEmailNotifications',
        component: () => import('./views/EmailNotificationsSettings.vue')
    },

    {
        path: 'settings/company-preferences/currency-format-modal',
        name: 'CurrencyFormatModal',
        component: () => import('./views/CurrencyFormatModal.vue')
    },
    {
        path: 'settings/company-preferences/update-company-details',
        name: 'UpdateCompanyDetails',
        component: () => import('./views/UpdateCompanyDetails.vue')
    },
    {
        path: 'settings/company-preferences/categories',
        name: 'Categories',
        component: () => import('./views/Categories.vue')
    },
    {
        path: 'settings/company-preferences/client-and-sales',
        name: 'ClientAndSales',
        component: () => import('./views/ClientAndSales.vue')
    },
    {
        path: 'settings/company-preferences/expenses-by-customer',
        name: 'ExpensesByCustomer',
        component: () => import('./views/ExpensesByCustomer.vue')
    },
    {
        path: 'settings/company-preferences/managing-bills-list',
        name: 'ManagingBillsList',
        component: () => import('./views/ManagingBillsList.vue')
    },
    // Add other settings routes here as needed
];
